var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("累计触发人次： "+_vm._s(_vm.sendNum))]),_c('div',{attrs:{"id":"map"}},[_vm._v("暂无数据...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }